<template>
    <div>
        <table v-if="projectList" class="datatable">
            <caption class="caption">Project list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminProjectList.table.name") }}</th>
                <th scope="col">{{ $t("admin.adminProjectList.table.enabled") }}</th>
            </tr>
            <tr v-for="(project, index) in projectList" v-bind:key="index">
                <td><router-link :to="'/admin/projectView/' + project.id">{{ project.name }}</router-link></td>
                <td>{{ project.enabled ? $t("common.yes") : $t("common.no") }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminProjectList',
        props: [ 'groupId' ],
        data: function() {
            return { projectList: [] };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                adminService.projectList(this.groupId).then((data) => {
                    this.projectList = data;
                }).catch((err) => {
                    console.error('Unable to list project: ', err)
                });
            }
        }
    }
</script>
